// Utility functions untuk nomor pesanan
export const generateOrderNumber = () => {
  const now = new Date();
  const year = now.getFullYear().toString().slice(-2); // 2 digit tahun
  const month = (now.getMonth() + 1).toString().padStart(2, '0'); // 2 digit bulan
  const day = now.getDate().toString().padStart(2, '0'); // 2 digit hari
  const hour = now.getHours().toString().padStart(2, '0'); // 2 digit jam
  const minute = now.getMinutes().toString().padStart(2, '0'); // 2 digit menit
  const second = now.getSeconds().toString().padStart(2, '0'); // 2 digit detik
  
  // Format: NH-YYMMDD-HHMMSS (contoh: NH-250901-143052)
  return `NH-${year}${month}${day}-${hour}${minute}${second}`;
};

// Function untuk memvalidasi format nomor pesanan
export const isValidOrderNumber = (orderNumber) => {
  if (!orderNumber) return false;
  
  // Pattern: NH-YYMMDD-HHMMSS
  const pattern = /^NH-\d{6}-\d{6}$/;
  return pattern.test(orderNumber);
};

// Function untuk mengambil tanggal dari nomor pesanan
export const getDateFromOrderNumber = (orderNumber) => {
  if (!isValidOrderNumber(orderNumber)) return null;
  
  try {
    const datePart = orderNumber.split('-')[1]; // YYMMDD
    const timePart = orderNumber.split('-')[2]; // HHMMSS
    
    const year = 2000 + parseInt(datePart.slice(0, 2));
    const month = parseInt(datePart.slice(2, 4)) - 1; // Month is 0-indexed
    const day = parseInt(datePart.slice(4, 6));
    const hour = parseInt(timePart.slice(0, 2));
    const minute = parseInt(timePart.slice(2, 4));
    const second = parseInt(timePart.slice(4, 6));
    
    return new Date(year, month, day, hour, minute, second);
  } catch (error) {
    console.error('Error parsing order number:', error);
    return null;
  }
};

// Function untuk format display nomor pesanan
export const formatOrderNumberDisplay = (orderNumber) => {
  if (!orderNumber) return '-';
  return orderNumber;
};
